/**
 * @fileoverview A function that formats the given input to a JSX element.
 *
 * @example
 * formatOutput('Hello')
 */

/**
 * @function formatOutput
 * @description Formats the given input to a JSX element.
 * @param {string | number | boolean} input - The input to format.
 * @returns {JSX.Element} - The formatted input.
 */
export function formatOutput(input: string | number | boolean): JSX.Element {
    let isDefined = false
    if (input !== undefined && input !== null) {
        isDefined = true
    }
    if (typeof input === 'string') {
        isDefined = input.length > 0
    }
    return !isDefined ? (
        <span className="text-gray-400">n/a</span>
    ) : (
        <span className="text-gray-900">{input}</span>
    )
}

/**
 * @function formatOutputArray
 * @description Formats the given array to a JSX element.
 * @param {string[] | undefined} input - The input to format.
 * @returns {JSX.Element} - The formatted input.
 */
export function formatOutputArray(input: string[] | undefined): JSX.Element {
    const isDefined = input !== undefined && input.filter((x) => x).length > 0
    return !isDefined ? (
        <span className="text-gray-900">All studies</span>
    ) : (
        <span className="text-gray-900">{input?.join(', ')}</span>
    )
}
